import { useEffect, useRef } from "react";

const FILTER_NAVY = 'brightness(0) saturate(100%) invert(14%) sepia(22%) saturate(700%) hue-rotate(175deg) brightness(0.88)';
const FILTER_ORANGE = 'brightness(0) saturate(100%) invert(55%) sepia(95%) saturate(700%) hue-rotate(340deg) brightness(1.05)';

const clients = [
  {
    name: "MINERA HMC S.A",
    logo: "https://minerahmc.cl/wp-content/uploads/2023/07/HMC.svg",
    type: "img",
    noFilter: false,
  },
  {
    name: "MINERA SAN GERÓNIMO",
    logo: "https://cmsg.cl/wp-content/uploads/2022/04/Logo_minera.svg",
    type: "img",
    noFilter: false,
  },
  {
    name: "MINERA DEL VALLE",
    logo: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/ef63efd5-d6a4-4a5e-9592-866f6ff44b76_Gemini_Generated_Image_7gim5x7gim5x7gim.png?v=4b3cfcdbf56f68bd342d0dec8735d6aa",
    type: "img",
    noFilter: true,
  },
  {
    name: "SOMINOR",
    logo: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/be45ff11-9a27-4fcc-bb19-e3dd7a70c537_Gemini_Generated_Image_6c6ijr6c6ijr6c6i.png?v=080b493232fb6cd014529a0596edb404",
    type: "img",
    noFilter: true,
  },
  {
    name: "RENTAMAQ",
    logo: "https://hydrolix.cl/images/content/rentamaq.png",
    type: "img",
    noFilter: true,
  },
  {
    name: "CONSTRUCTORA MAP",
    logo: "https://scontent-scl3-1.xx.fbcdn.net/v/t39.30808-6/472312220_2005993549878705_2953894624680390277_n.jpg?_nc_cat=102&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=Sd99AlNK7MQQ7kNvwExBmOU&_nc_oc=Adpl0tx1hNLg2TJ7_X0JFFtGmFoJxu1Q5smSnuBnwDxe0PJwRlUua76IVxg5A82T_9UDYRmy3N5pNajEzr83-dQ0&_nc_zt=23&_nc_ht=scontent-scl3-1.xx&_nc_gid=N92FFjPfC_LRvSgjgP23kA&_nc_ss=7b289&oh=00_Af38ddFYHTw5L44d0ZrJXmWuVJvgb6ji9EwTZAJ31t6cxg&oe=69EEF7ED",
    type: "img",
    noFilter: true,
  },
  {
    name: "CONSTRUCTORA INGEVEC",
    logo: "https://acjmaquinaria.cl/images/INGEVEC.jpg",
    type: "img",
    noFilter: true,
  },
  {
    name: "CONSTRUCTORA FG",
    logo: "https://www.empresasfg.com/public/img/logo-empresasFG_azul.svg",
    type: "img",
    noFilter: false,
  },
  {
    name: "CONSTRUCTORA NOVAL",
    logo: "https://fundacioncchc.cl/logo-empresas/logos-empresas/constructora-noval-ltda.png",
    type: "img",
    noFilter: true,
  },
  {
    name: "CONSTRUCTORA NOVATEC",
    logo: "https://tramasa.cl/wp-content/uploads/2025/03/logo-novatec-300x300.png",
    type: "img",
    noFilter: true,
  },
  {
    name: "ECOMAC",
    logo: "https://www.ecomac.cl/_astro/ecomac-logo-white.C_KOKnBR_ZGFqe1.webp",
    type: "img",
    noFilter: false,
  },
  {
    name: "CONSTRUCTORA ECASA",
    logo: "https://ecasa.cl/images/logo_nuevo.png",
    type: "img",
    noFilter: false,
  },
  {
    name: "CONSTRUCTORA EBCO",
    logo: "https://storage.readdy-site.link/project_files/5397651f-fa4a-4daf-a2cb-668ede89c5b0/ab589b1e-d8d6-405c-aed6-4c9999eebae6_Gemini_Generated_Image_zfkxwizfkxwizfkx.png?v=cb2189a24cc01be08aea3a4ba6dfc2cc",
    type: "img",
    noFilter: true,
  },
  {
    name: "CONSTRUCTORA RVC",
    logo: "https://cvingenieria.cl/rvc.png",
    type: "img",
    noFilter: true,
  },
  {
    name: "CONSTRUCTORA IHABITA",
    logo: "https://ihabita.cl/imagenes/logo-habita.svg",
    type: "img",
    noFilter: false,
  },
  {
    name: "ACCIONA CONSTRUCCION S.A.",
    logo: "https://www.acciona.cl/content/dam/accioname/logo-acciona.svg",
    type: "img",
    noFilter: true,
  },
  {
    name: "FINNING CHILE",
    logo: "https://www.finning.com/etc/designs/dxm/clientlibs/img/dxm/logo_finning-cat.png",
    type: "img",
    noFilter: true,
  },
  {
    name: "GRUAS PINGON",
    logo: "https://pingon.cl/wp-content/uploads/2024/10/Nuevo-Pingon-con-letras.png",
    type: "img",
    noFilter: true,
  },
  {
    name: "GRUAS M10",
    logo: "https://www.m10.la/wp-content/uploads/2021/05/logotipo-web-300x139.png",
    type: "img",
    noFilter: true,
  },
  {
    name: "ARIDOS ACONCAGUA",
    logo: "",
    type: "text",
    noFilter: false,
  },
  {
    name: "UNICON",
    logo: "https://www.uniconchile.cl/wp-content/uploads/2025/03/unicon-logo-sitio-web.png",
    type: "img",
    noFilter: true,
  },
  {
    name: "AGRICOLA SANTA ELVIRA",
    logo: "https://www.santaelvira.cl/sitio/wp-content/uploads/2018/03/nuevo-logo-santa-elvira-editable.png",
    type: "img",
    noFilter: true,
  },
];

// Duplicate for seamless loop
const allClients = [...clients, ...clients, ...clients];

export default function ClientsBanner() {
  const trackRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animFrame: number;
    let pos = 0;
    const speed = 0.5;
    const singleSetWidth = track.scrollWidth / 3;

    const animate = () => {
      pos += speed;
      if (pos >= singleSetWidth) {
        pos = 0;
      }
      track.style.transform = `translateX(-${pos}px)`;
      animFrame = requestAnimationFrame(animate);
    };

    animFrame = requestAnimationFrame(animate);

    const handleMouseEnter = () => cancelAnimationFrame(animFrame);
    const handleMouseLeave = () => {
      animFrame = requestAnimationFrame(animate);
    };

    track.addEventListener("mouseenter", handleMouseEnter);
    track.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      cancelAnimationFrame(animFrame);
      track.removeEventListener("mouseenter", handleMouseEnter);
      track.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <section className="py-14 bg-[#f7f8fa] border-y border-gray-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 mb-8 text-center">
        <span className="inline-block bg-orange-50 text-orange-600 text-xs font-bold uppercase tracking-widest px-4 py-1.5 rounded-full mb-4">
          Confianza
        </span>
        <h2 className="text-4xl md:text-6xl font-black text-[#1c2b38] leading-tight tracking-tight">
          Empresas que{" "}
          <span className="relative inline-block">
            <span className="relative z-10 text-orange-500">confían</span>
            <span className="absolute -bottom-1 left-0 w-full h-3 bg-orange-100 rounded-full -z-0" />
          </span>{" "}
          <br className="hidden md:block" />
          en nosotros
        </h2>
      </div>

      <div className="relative overflow-hidden">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-[#f7f8fa] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-[#f7f8fa] to-transparent z-10 pointer-events-none" />

        <div
          ref={trackRef}
          className="flex items-center gap-16 will-change-transform"
          style={{ width: "max-content" }}
        >
          {allClients.map((client, i) => (
            <div
              key={`${client.name}-${i}`}
              className="flex flex-col items-center justify-center gap-3 min-w-[160px] group cursor-default"
            >
              <div className="h-16 w-40 flex items-center justify-center">
                {client.type === "img" ? (
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="max-h-14 max-w-[140px] object-contain transition-all duration-300 client-logo"
                    style={{ filter: client.noFilter ? 'none' : FILTER_NAVY }}
                    onMouseEnter={(e) => { if (!client.noFilter) e.currentTarget.style.filter = FILTER_ORANGE; }}
                    onMouseLeave={(e) => { if (!client.noFilter) e.currentTarget.style.filter = FILTER_NAVY; }}
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = "none";
                      const parent = target.parentElement;
                      if (parent) {
                        parent.innerHTML = `<span class="text-[#1c2b38] font-bold text-lg tracking-tight opacity-50 group-hover:opacity-100 transition-opacity duration-300">${client.name}</span>`;
                      }
                    }}
                  />
                ) : (
                  <span className="text-[#1c2b38] font-bold text-lg tracking-tight opacity-50 group-hover:opacity-100 transition-opacity duration-300">
                    {client.name}
                  </span>
                )}
              </div>
              <span className="text-xs text-gray-400 font-medium text-center leading-tight max-w-[140px] group-hover:text-orange-500 transition-colors duration-300">
                {client.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
